import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

axios.defaults.baseURL = process.env.VUE_APP_SERVER;

export default new Vuex.Store({
    state: {
        user: [],
        count: 0
    },

    mutations: {
        setUserData(state, userData) {
            state.user = userData;
        },

        setUserStatus(state , status){
            state.user.status = status;
        },

        setNotificationCount(state, count) {
            state.count = count;
        },

        setUserEnableVideoUpload(state , enable_video_upload){
            state.user.enable_video_upload = enable_video_upload;
        },
        
        storeToken(state, userToken) {
            state.user.token = userToken;
        },

        logout(state) {
            state.user = [];
            state.user.token = null;
            state.count = 0;
        },

        setAcountUser(state, data) {
            state.user.accountuser = data;
        },
    },

    actions: {
        login({ commit }, credentials) {
            return axios.post("login", credentials).then(({ data }) => {
                commit("setUserData", data);
                commit("setNotificationCount", data.count);
                commit("storeToken", data.token);
            });
        },

        loginByBtn({ commit }) {
            commit("setUserData", []);
            commit("setNotificationCount", 0);
            commit("storeToken", null);
        },

        logoutTeacher({ commit }) { 
            return axios.post("logout")
                .then(() => {
                    // commit("logout");
                    commit("setUserData", []);
                    commit("setNotificationCount", 0);
                    commit("storeToken", null);
                })
                .catch((error) => {
                    console.log("Log Out API Error", error.response);
                });
        },
        
        logoutStudent({ commit }) { 
            return axios.post("logout")
                .then(() => {
                    // commit("logout");
                    commit("setUserData", []);
                    commit("setNotificationCount", 0);
                    commit("storeToken", null);
                })
                .catch((error) => {
                    console.log("Log Out API Error", error.response);
                });
        },
    },

    getters: {
        isLoggedIn: (state) => Object.keys( state.user ).length == 0 ? false: true,

        userType: (state) => {
            if (state.user && state.user.usertype) {
                return state.user.usertype;
            }
        },

        userStatus: (state) => {
            if (state.user && state.user.status) {
                return state.user.status;
            }
        },
    
        teacherId: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.teacher_id ) {
                return state.user.accountuser.teacher_id;
            }
        },

        studentId: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.student_id) {
                return state.user.accountuser.student_id;
            }          
        },

        personalId: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.personal_id) {
                return state.user.accountuser.personal_id;
            }
        },
        
        schoolId: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.school_id) {
                return state.user.accountuser.school_id;
            }
        },
        
        userName: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.name) {
                return state.user.accountuser.name;
            }
            if (state.user && state.user.accountuser && !state.user.accountuser.name) {
                return state.user.accountuser.school_name;
            }
        },

        userEmail: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.email) {
                return state.user.accountuser.email;
            }
        },

        userToken: (state) => {
            if (state.user && state.user.token) {
                return state.user.token;
            }
        },

        count: (state) => {
            if (state.count) {
                return state.count;
            }
        },

        userSocialID: (state) => {
            if (state.user && state.user.accountuser && state.user.accountuser.social_media_id) {
                return state.user.accountuser.social_media_id;
            }
        }
    },

    plugins: [createPersistedState()],
});
